import { render, staticRenderFns } from "./refund.vue?vue&type=template&id=67dafd4b&scoped=true"
import script from "./refund.vue?vue&type=script&lang=js"
export * from "./refund.vue?vue&type=script&lang=js"
import style0 from "./refund.vue?vue&type=style&index=0&id=67dafd4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dafd4b",
  null
  
)

export default component.exports